import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { LocationCity } from "@material-ui/icons";
import { useTranslation } from 'react-i18next';

interface ICityData {
    cityId: string;
    cityName: string | null;
    postalCode: string | null;
    province: string | null;
}

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<ICityData | null>;
export const Stad = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');
    
    const label = props.label || tDatatypes('stadLabel') || "Stad";
    
    const displayValue = props.value ? 
        `${props.value.postalCode || ''} ${props.value.cityName || ''}`.trim() || 
        props.value.cityName || 
        'Onbekend' 
        : null;
    
    return (<Caption {...props} caption={label} icon={<LocationCity />}>
        {displayValue}
    </Caption>)
}
